
import React, { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import DashboardLoader from '@/components/dashboard/DashboardLoader';
import ProfileTabs from './components/ProfileTabs';
import ProfileHeader from './components/ProfileHeader';

const JobSeekerProfile = () => {
  const { user, profile, isLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const tabFromQuery = queryParams.get('tab');
  const [activeTab, setActiveTab] = useState(tabFromQuery || 'personal');
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    if (tabFromQuery) {
      setActiveTab(tabFromQuery);
    }
  }, [tabFromQuery]);

  const handleRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  const handleGoBack = () => {
    navigate('/job-seeker-dashboard');
  };

  if (isLoading) {
    return <DashboardLoader />;
  }

  if (!user) {
    return <Navigate to="/auth" />;
  }

  if (profile?.role !== 'job_seeker') {
    return <Navigate to="/onboarding" />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-[#F0F9FF] to-[#E0F2FE] p-6">
      <div className="max-w-4xl mx-auto">
        <ProfileHeader handleGoBack={handleGoBack} />
        
        <ProfileTabs 
          activeTab={activeTab} 
          setActiveTab={setActiveTab} 
          userId={user.id} 
          profile={profile}
          refreshTrigger={refreshTrigger}
          onRefresh={handleRefresh}
        />
      </div>
    </div>
  );
};

export default JobSeekerProfile;
